"use client";
import { useState, useEffect, Suspense } from "react";
import StoreHeader from "@/app/components/common/store/StoreHeader";
import StoreProductsPageSkeleton from "@/app/components/elements/skeletons/StoreProductsPageSkeleton";
import StoreTabs from "@/app/components/common/store/StoreTabs";
import StoreAllProducts from "../StoreAllProducts";
import StoreDealsProducts from "../StoreDealsProducts";
import useStore from "@/app/lib/features/store/store.hook";
import {
  StoreSellerData,
  StoreProductsData,
} from "@/app/lib/features/store/store.types";
import { trackSellerView } from "@/app/lib/tracking/interactions";

interface StoreTabPageClientProps {
  initialData: StoreSellerData;
  activeTabKey: string;
  initialProductsPromise: Promise<StoreProductsData | null>;
}

const StoreTabPageClient = ({
  initialData,
  activeTabKey,
  initialProductsPromise,
}: StoreTabPageClientProps) => {
  const [searchValue, setSearchValue] = useState("");

  const {
    seller,
    tabs,
    search,
    currentSlug,
    fetchStoreFullData,
    reset,
  } = useStore();

  useEffect(() => {
    document.body.classList.add("hide-main-header");
    return () => document.body.classList.remove("hide-main-header");
  }, []);

  // Reset unmount'ta DEĞİL, mount'ta ve yalnızca mağaza gerçekten değiştiyse.
  // Unmount'ta sıfırlamak sekmeler arası geçişte (aynı mağaza) auth'lu seller
  // verisini de çöpe atıyordu; header yeniden anonim initialData'ya düşüp
  // puan/rozet/takip durumu gidip geliyordu. Aynı mağazada kalırken Redux
  // korunuyor → sekme geçişi hiçbir alanı oynatmıyor.
  useEffect(() => {
    const slug = initialData.seller.slug;
    if (currentSlug && currentSlug !== slug) {
      reset();
    }
    fetchStoreFullData(slug);
    if (initialData.seller.id) trackSellerView(initialData.seller.id);
  }, [initialData.seller.slug]); // eslint-disable-line react-hooks/exhaustive-deps

  // SSR fallback: skeleton kapısı YOK — StorePageClient ile aynı desen.
  // initialData her sekmede SSR'dan geldiğinden Redux boşken doğrudan render
  // edilir, auth'lu client fetch tamamlanınca tazelenir.
  const activeSeller = seller ?? initialData.seller;
  const activeTabs = tabs.length ? tabs : initialData.tabs;
  const activeSearch = search ?? initialData.search;

  const isDeals = activeTabKey.includes("deals");

  return (
    <div className="min-h-screen bg-gray-50">
      <StoreHeader seller={activeSeller} />
      <StoreTabs
        storeName={activeSeller.name}
        searchPlaceholder={activeSearch.placeholder}
        tabs={activeTabs}
        sellerSlug={activeSeller.slug}
        activeTabKey={activeTabKey}
        searchValue={searchValue}
        onSearchChange={setSearchValue}
      />
      <div className="container-main py-6">
        {/* Streaming: ürün bileşeni use(promise) ile suspend olur —
            header + tab bar anında görünür, ürün alanı skeleton gösterir. */}
        <Suspense fallback={<StoreProductsPageSkeleton />}>
          {isDeals ? (
            <StoreDealsProducts
              slug={activeSeller.slug}
              search={searchValue}
              initialProductsPromise={initialProductsPromise}
            />
          ) : (
            <StoreAllProducts
              slug={activeSeller.slug}
              search={searchValue}
              initialProductsPromise={initialProductsPromise}
            />
          )}
        </Suspense>
      </div>
    </div>
  );
};

export default StoreTabPageClient;